import { render, staticRenderFns } from "./step7component_and_resource_base.vue?vue&type=template&id=545cb926&scoped=true"
import script from "./step7component_and_resource_base.vue?vue&type=script&lang=js"
export * from "./step7component_and_resource_base.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545cb926",
  null
  
)

export default component.exports